import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import { SectionData } from '../types';

export const NameCell: FC<ICellRendererParams<SectionData>> = ({ data }) => {
  if (data == null) {
    return <div>-</div>;
  }

  return <div>{data.sectionName}</div>;
};
